export default [
  {
    srno: "01",
    name: "sahil kanerkar",
    mobile: "9892130802",
    email: "sahil.kanerkar@aiab.in",
    id: "12345678901",
    status: "Completed",
    summary: "+add",
  },
  {
    srno: "01",
    name: "sahil kanerkar",
    mobile: "9892130802",
    email: "sahil.kanerkar@aiab.in",
    id: "12345678901",
    status: "Completed",
    summary: "+add",
  },
  {
    srno: "01",
    name: "sahil kanerkar",
    mobile: "9892130802",
    email: "sahil.kanerkar@aiab.in",
    id: "12345678901",
    status: "Completed",
    summary: "+add",
  },
  {
    srno: "01",
    name: "sahil kanerkar",
    mobile: "9892130802",
    email: "sahil.kanerkar@aiab.in",
    id: "12345678901",
    status: "Completed",
    summary: "+add",
  },
];
